var map = {
	"./ada.png": 2152,
	"./akt.png": 5679,
	"./aleph.png": 4229,
	"./atlas.png": 7523,
	"./atom.png": 1892,
	"./ats.png": 5593,
	"./audio.png": 9015,
	"./aury.png": 8797,
	"./avax.png": 4924,
	"./bch.png": 4386,
	"./bdp.png": 8427,
	"./bnb.png": 8223,
	"./btc.png": 8742,
	"./c98.png": 4453,
	"./cope.png": 3057,
	"./cro.png": 7108,
	"./crp.png": 6667,
	"./cvc.png": 4280,
	"./cys.png": 2396,
	"./dfl.png": 6578,
	"./doge.png": 1838,
	"./dot.png": 1030,
	"./dxl.png": 6978,
	"./eth.png": 3716,
	"./fab.png": 552,
	"./fant.png": 9761,
	"./fida.png": 4739,
	"./front.png": 7473,
	"./ftt.png": 9722,
	"./gene.png": 2246,
	"./gmt.png": 3864,
	"./grt.png": 429,
	"./gst.png": 1791,
	"./hbb.png": 616,
	"./hxro.png": 6983,
	"./ichi.png": 804,
	"./insur.png": 527,
	"./inv.png": 6208,
	"./jet.png": 7958,
	"./kin.png": 4938,
	"./like.png": 6635,
	"./link.png": 5881,
	"./ltc.png": 4391,
	"./luna.png": 7172,
	"./maps.png": 5366,
	"./matic.png": 2249,
	"./media.png": 5807,
	"./mer.png": 6808,
	"./mnde.png": 8069,
	"./mngo.png": 2612,
	"./msol.png": 8381,
	"./near.png": 3511,
	"./orca.png": 2017,
	"./oxs.png": 8326,
	"./oxy.png": 7234,
	"./polis.png": 6792,
	"./port.png": 5451,
	"./prism.png": 1660,
	"./prq.png": 1504,
	"./ramp.png": 5967,
	"./ray.png": 7466,
	"./ren.png": 958,
	"./rin.png": 2281,
	"./samo.png": 5262,
	"./scnsol.png": 8673,
	"./shdw.png": 8324,
	"./shib.png": 5436,
	"./shill.png": 5668,
	"./slim.png": 2725,
	"./slnd.png": 225,
	"./slrs.png": 4509,
	"./sny.png": 9952,
	"./sol.png": 8144,
	"./solape.png": 7113,
	"./solx.png": 8222,
	"./spwn.png": 6804,
	"./srb.png": 1248,
	"./srm.png": 2216,
	"./step.png": 4959,
	"./suchi.png": 8348,
	"./sunny.png": 9543,
	"./trx.png": 8169,
	"./tryb.png": 4890,
	"./tulip.png": 9390,
	"./vlx.png": 6510,
	"./waves.png": 2010,
	"./woof.png": 284,
	"./xrp.png": 6312
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6269;